/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_about_section_optimizer = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy — Team Optimization Algorithm`)
};

const es_about_section_optimizer = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy — Algoritmo de optimización de equipo`)
};

const de_about_section_optimizer = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy — Team-Optimierungsalgorithmus`)
};

const nl_about_section_optimizer = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy — Teamoptimalisatiealgoritme`)
};

const fr_about_section_optimizer = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy — Algorithme d’optimisation d’équipe`)
};

const it_about_section_optimizer = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy — Algoritmo di ottimizzazione team`)
};

const pt_br2_about_section_optimizer = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy — Algoritmo de otimização de equipe`)
};

const pt_about_section_optimizer = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1 Fantasy — Algoritmo de otimização de equipa`)
};

const ja_about_section_optimizer = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1ファンタジー — チーム最適化アルゴリズム`)
};

const zh_about_section_optimizer = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F1梦幻赛车 — 车队优化算法`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const about_section_optimizer = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.about_section_optimizer(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("about_section_optimizer", locale)
	if (locale === "en") return en_about_section_optimizer(inputs)
	if (locale === "es") return es_about_section_optimizer(inputs)
	if (locale === "de") return de_about_section_optimizer(inputs)
	if (locale === "nl") return nl_about_section_optimizer(inputs)
	if (locale === "fr") return fr_about_section_optimizer(inputs)
	if (locale === "it") return it_about_section_optimizer(inputs)
	if (locale === "pt-BR") return pt_br2_about_section_optimizer(inputs)
	if (locale === "pt") return pt_about_section_optimizer(inputs)
	if (locale === "ja") return ja_about_section_optimizer(inputs)
	return zh_about_section_optimizer(inputs)
};